import { render } from "./SplashView.vue?vue&type=template&id=31d8c206&scoped=true&ts=true"
import script from "./SplashView.vue?vue&type=script&lang=ts"
export * from "./SplashView.vue?vue&type=script&lang=ts"

import "./SplashView.scss?vue&type=style&index=0&id=31d8c206&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d8c206"]])

export default __exports__